export default {
  title: 'Workspace',
  description: 'You can see below all your workspaces. Select the one you are interested in to move on.'
}



// WEBPACK FOOTER //
// ./src/translations/en/workspace.js